import React, { useEffect, useRef, useState } from "react";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import InputGroup from "canvas-core-react/lib/InputGroup";
import IconTip from "canvas-core-react/lib/IconTip";
import IconLock from "canvas-core-react/lib/IconLock";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import RadioButton from "canvas-core-react/lib/RadioButton";
import { useTranslation } from "react-i18next";

import Checkbox from "../../shared/custom-components/checkbox";
import ErrorMessage from "../../shared/custom-components/errorMessage";
import Modal from "../../utils/customModal";
import useApi from "../../hooks/useApi";
import {
  getAvailableOptions,
  getDefaultState,
  renderTermsContent,
} from "./termsUtil";

const TermExtension = ({
  title = "Lacteos del Sur",
  country = "CR",
  mode = 1,
  handleBack,
  companyId,
}) => {
  const [termLimit, setTermLimit] = useState({ start: 16, end: 180 });
  const [state, setState] = useState(getDefaultState(mode));
  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState({
    show: false,
    content: "@@@@vvvvvvvvv",
  });

  const { t } = useTranslation();
  const { getApiCAll } = useApi();

  const { alertMessage, labels, buttonsText, formErrors, billsLabel } = {
    labels: t("providers.termExtension", defaultObj),
    alertMessage: t("providers.termExtension.alert", defaultObj),
    buttonsText: t("general.buttons", defaultObj),
    formErrors: t("general.formErrors", defaultObj),
    billsLabel: t("providers.termExtension.bills", {
      ...defaultObj,
      start: termLimit.start,
      end: termLimit.end,
    }),
  };

  const handleData = ({ target: { name, value } }) => {
    const newValue = name === names.globalApprobe ? value === "true" : value;
    const payer = [names.globalApprobe, names.typeRelation].includes(name)
      ? ""
      : name === names.payer
      ? value
      : state.payer;

    setState((prev) => ({ ...prev, [name]: newValue, payer }));
  };

  const global = state.globalApprobe || state.typeRelation === "globalDiscount";
  const customClass = `col-${global ? 4 : 5}`;

  const onSubmit = () => {
    const defaultError = {
      message: formErrors.unselected,
      label: "Error",
    };

    const errors = Object.keys(state).reduce((prev, current) => {
      const valueRef = state[current];

      if (current === names.timeLimit) {
        if (
          !valueRef ||
          !(valueRef >= termLimit.start && valueRef <= termLimit.end)
        ) {
          prev[current] = defaultError;
        }
      }

      if (current === names.payer && global && !valueRef)
        prev[current] = defaultError;

      if (current === names.globalApprobe && valueRef === null && mode === 1)
        prev[current] = defaultError;

      if (current === names.terms && !valueRef) prev[current] = defaultError;
      if (current === names.typeRelation && !valueRef)
        prev[current] = defaultError;

      return prev;
    }, {});

    const alertInfo =
      mode === 2 &&
      (state.typeRelation === "globalDiscount" ||
        state.typeRelation === "discount");

    setErrors(errors);
    if (!Object.keys(errors).length) {
      setState((prev) => ({ ...prev, alert: !alertInfo ? "success" : "info" }));
    }
  };

  const handleTerms = () => {
    setModal({ show: true, content: renderTermsContent() });
  };

  const getCountryTerm = async () => {
    try {
      const [
        {
          data: {
            data: { daysExtensionTerm },
          },
        },
        {
          data: {
            data: { content },
          },
        },
      ] = await Promise.all([
        getApiCAll(`/companies/extension-term/plazo-max-client/${companyId}`),
        getApiCAll(`/parameters/plazos/${country}`),
      ]);

      if (content.length) {
        setTermLimit({ start: +content[0]?.value, end: +daysExtensionTerm });
      }
    } catch (error) {
      console.log("ERRRP", { error });
    }
  };

  useEffect(() => {
    getCountryTerm();
  }, []);

  useEffect(() => {
    if (state.alert) alertRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [state.alert]);

  const availableOptions = getAvailableOptions(mode, global);
  const buttonFunc = state.alert ? handleBack : onSubmit;

  const alertRef = useRef();
  const disabled = !!state.alert;

  console.log({ state, errors, termLimit });

  return (
    <>
      <div className="term-extension">
        <h2 className="link-primary-color">
          <IconLock size={24} className="link-primary-color mb-3 mr-2" />{" "}
          {title}
        </h2>
        <div className="term-header my-5">
          <h3 className="my-3">
            {labels.title} - {labels.subtitles[mode]}
          </h3>
          <p className="my-4">{labels.titleDescription}</p>
          {mode !== 0 && <p>{labels.titleDescriptionSpecial}</p>}
        </div>
        <div className="row justify-content-between my-5">
          {Object.keys(availableOptions).map((item) => {
            const { legend, name, items } = availableOptions[item];
            return (
              <InputGroup
                key={name}
                legend={legend}
                className={`${customClass} fieldset-fix`}
                error={errors[name]}
                disabled={disabled}
              >
                {items.map(({ value, label, description }) => (
                  <div key={value}>
                    <RadioButton
                      defaultChecked={state[name] === value}
                      key={label}
                      label={label}
                      name={name}
                      onChange={handleData}
                      value={value}
                    />
                    {description}
                  </div>
                ))}
              </InputGroup>
            );
          })}
          <div className={customClass}>
            <h3
              style={defaultStyles}
              className={errors.timeLimit ? "error" : ""}
            >
              {billsLabel.title}
            </h3>
            <p>{billsLabel.subtitle}</p>
            <p className="my-3 link-primary-color d-flex align-items-center">
              <IconTip />
              <p className="ml-3" style={{ marginBottom: 2 }}>
                {billsLabel.tip}
              </p>
            </p>
            <div className="d-flex align-items-center">
              <input
                input-error
                className={`input-date-fixed ${
                  errors.timeLimit ? " input-error" : ""
                }`}
                maxLength={3}
                name="timeLimit"
                value={state.timeLimit}
                onChange={handleData}
                disabled={disabled}
              />
              <p className="ml-2 font-weight-bold"> {billsLabel.days}</p>
            </div>
            {errors.timeLimit && (
              <ErrorMessage error={formErrors.invalidNumber} />
            )}
          </div>
        </div>
        <div style={{ marginTop: "5rem", marginBottom: "2rem" }}>
          <Checkbox
            label={labels.termsLabel}
            className={errors.terms && "error font-weight-bolder"}
            onChange={() =>
              handleData({ target: { name: "terms", value: !state.terms } })
            }
            checked={state.terms}
            disabled={disabled}
          />
          <p
            className="link-primary-color font-weight-bold mt-3"
            style={{ marginBottom: state.alert ? "2rem" : "5rem" }}
            onClick={handleTerms}
          >
            {labels.terms}
          </p>
        </div>
        {state.alert && (
          <AlertBanner r type={state.alert} className="alert-fix-width">
            <div
              ref={alertRef}
              dangerouslySetInnerHTML={{ __html: alertMessage[state.alert] }}
            ></div>
          </AlertBanner>
        )}
      </div>

      <div className="form-actions clearfix">
        <SecondaryButton id={`send-invitation`} onClick={handleBack}>
          {buttonsText.back}
        </SecondaryButton>
        <PrimaryButton id={`send-invitation`} onClick={buttonFunc}>
          {disabled ? buttonsText.leave : buttonsText.save}
        </PrimaryButton>
      </div>
      <Modal show={modal.show}>{renderTermsContent()}</Modal>
    </>
  );
};

export default TermExtension;

const defaultObj = { returnObjects: true };

const defaultStyles = {
  fontSize: "1.60rem",
  marginTop: "5px",
  marginBottom: "5px",
};

const names = {
  globalApprobe: "globalApprobe",
  typeRelation: "typeRelation",
  payer: "payer",
  timeLimit: "timeLimit",
  terms: "terms",
};
